import { forwardRef, useCallback } from "react";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { Form } from "@shared/components/Form";
import { getAgreementProductsService } from "@modules/agreements/services/realAgreementProductService";

interface AgreementProductsAutocompleteProps extends Omit<FormAutocompleteProps, "options"> {
  /** ID do convênio para filtrar os produtos reais */
  agreement?: number | string | null;
}

export const AgreementProductsAutocomplete = forwardRef<
  HTMLInputElement,
  AgreementProductsAutocompleteProps
>(({ agreement, ...props }, ref) => {
  const queryHook = useCallback(
    async ({ ids }: { ids?: (number | string)[] } = {}) => {
      const products = await getAgreementProductsService(
        agreement ? Number(agreement) : undefined
      );

      if (!ids?.length) return products;

      const idsAsStrings = ids.map(String);
      return products.filter((product) => idsAsStrings.includes(String(product.id)));
    },
    [agreement]
  );

  return <Form.Autocomplete {...props} ref={ref} queryHook={queryHook} />;
});

AgreementProductsAutocomplete.displayName = "AgreementProductsAutocomplete";
